<template>
  <div class="box-success">
    <p>{{props.list.introduce}}</p>
    <p>{{props.list.achievement}}</p>

    <!-- <img v-complete:src="list.image" alt="" /> -->
     <img
          v-complete:src="props.list.image"
          alt=""
        />
    <!-- <el-icon><OfficeBuilding /></el-icon> -->
  </div>
</template>

<script setup>
// import { OfficeBuilding } from "@element-plus/icons-vue";

import { reactive } from "vue";
const mydata = {

  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

};

const props = defineProps({
  list: {
    type: Object,
    default: () => {
      return {}
      
    },
  },
});










</script>

<style scoped lang="scss">
.box-success {
  width: 164px !important;
  height: 124px !important;
//   border: 1px solid rgb(0, 26, 255);
  background-color: #ffffff;
  box-shadow: 0px 5px 40px 0px #0000000d;
  padding: 16px;
  position: relative;
  p:nth-of-type(1) {
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: #009de0;
    
  }
  p:nth-of-type(2) {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #333333;
  }
  img {
    width:33px;
    height:33px;
    display: block;
    position: absolute;
    right: 21px;
    bottom: 20px;
  }
  //   :deep(.el-icon){
  //     position:absolute;
  //     right:21px;
  //     bottom:20px;
  //     font-size:33px;
  //     font-weight:100;
  //   }
}
</style>